module.exports = __webpack_public_path__ + "static/media/sss.49476176.jpeg";